export default function getDiaperBundleValue(store?: string) {
  if (store === 'hbca') return 85
  return 69.99
}
